export var reduxKey = '@@firstTimeFlags';
export var localStorageKey = '@@firstTimeFlags';
export var FirstTimeFlag;
(function (FirstTimeFlag) {
    FirstTimeFlag["ProfileHeroAidNotClosed"] = "isProfileHeroAidNotClosed";
    FirstTimeFlag["ProfileEditAidNotClosed"] = "isProfileEditAidNotClosed";
    FirstTimeFlag["WelcomePopupNotClosed"] = "isWelcomePopupNotClosed";
    FirstTimeFlag["FeedbackNotReceived"] = "isFeedbackNotReceived";
    FirstTimeFlag["ArtBackgroundNotUsed"] = "isArtBackgroundNotUsed";
    FirstTimeFlag["IsJournalCoverNotUsed"] = "isJournalCoverNotUsed";
    FirstTimeFlag["IsPortfolioPopupNotClosed"] = "isPortfolioPopupNotClosed";
})(FirstTimeFlag || (FirstTimeFlag = {}));
//# sourceMappingURL=constants.js.map